// 2022-07-20T17:32:28.995118 变成 2022-07-20 17:32
export function formatOrdertime(orderTime) {
    return orderTime ? orderTime.substring(0, 16).replace('T', ' ') : '';
}
export function refundStateTag(state) {
    const statusMap = {
        1: 'primary',
        2: 'warning',
        3: 'success',
        '-1': 'error'
    };
    return statusMap[state] ? statusMap[state] : '';
}
// 两个浮点数求和
export function accAdd(num1, num2) {
    var r1, r2, m;
    try {
        r1 = num1.toString().split('.')[1].length;
    } catch (e) {
        r1 = 0;
    }
    try {
        r2 = num2.toString().split('.')[1].length;
    } catch (e) {
        r2 = 0;
    }
    m = Math.pow(10, Math.max(r1, r2));

    return Math.round(num1 * m + num2 * m) / m;
}
// 客户账号状态  公共模板
export function user_status(state) {
    const statusMap = {
        on: '正常',
        off: '停用'
    };
    return statusMap[state] ? statusMap[state] : '';
}
// 数据明细 状态
export function data_detail_status_list(state) {
    const statusMap = {
        wait_audit: '待审核',
        receiving: '领取中',
        success: '领取成功',
        failed: '异常',
        not_enough: '余额不足/领取失败'
    };
    return statusMap[state] ? statusMap[state] : '';
}
export function user_type_list(state) {
    const statusMap = {
        super: '超级账户',
        admin: '管理员',
        user: '员工'
    };
    return statusMap[state] ? statusMap[state] : '';
}
export function client_user_status_list(state) {
    const statusMap = {
        wait_audit: '待审核',
        passed: '审核成功',
        failed: '审核失败',
        ban: '黑名单'
    };
    return statusMap[state] ? statusMap[state] : '';
}
export function client_user_status_type(state) {
    const statusMap = {
        wait_audit: 'info',
        passed: 'success',
        failed: 'warning',
        ban: 'danger'
    };
    return statusMap[state] ? statusMap[state] : '';
}

export function payment_use_merchant_withdraw_list(state) {
    const statusMap = {
        yes: '使用商户提现',
        no: '使用企业提现'
    };
    return statusMap[state] ? statusMap[state] : '';
}
export function put_bloo(state) {
    const statusMap = {
        on: 'true',
        off: 'false'
    };
    return statusMap[state] ? statusMap[state] : '';
}
// 手机号号码加空格
export function phone(state) {
    if (state) {
        return state.substr(0, 3) + ' ' + state.substr(3, 4) + ' ' + state.substr(7);
    }
}
// 金额取.后两位 不四舍五入
export function price(state) {
    if (state) {
        // 先截取当前数据到小数点后三位 （不会四舍五入）
        let tempVal = parseFloat(state).toFixed(3);
        // 再取该数值长度-1的内容
        let realVal = tempVal.substring(0, tempVal.length - 1);
        return realVal
    }
}
